export const AUTHORIZED_ACCESS_API_URL = 'ui/organization/authorized_access';

export const authorizedAccessQueryKeys = {
  all: [AUTHORIZED_ACCESS_API_URL],
};
